if (window.dataLayer) {
    let sentPageview = false;

    // send pageview when cf7 hook was fired
    $(document).on('wpcf7mailsent', function () {
        window.dataLayer.push({
            event: 'virtualPageview',
            virtualPageURL: location.pathname + 'success/',
            virtualPageTitle: 'CF7 Success',
        });
        sentPageview = true;
    });

    // when the hook hasn't fired, check if the class indicating this event exists and fire pageview
    if (!sentPageview && $('.wpcf7-mail-sent-ok').length) {
        setTimeout(function () {
            window.dataLayer.push({
                event: 'virtualPageview',
                virtualPageURL: location.pathname + 'success/',
                virtualPageTitle: 'CF7 Success',
            });
            sentPageview = true;
        }, 500);
    }
}
